export { LandingPageCard } from './LandingPageCard';
